import { render, staticRenderFns } from "./tan_needGz_portrait_botZheCont.vue?vue&type=template&id=a1fa22e8&scoped=true"
import script from "./tan_needGz_portrait_botZheCont.vue?vue&type=script&lang=js"
export * from "./tan_needGz_portrait_botZheCont.vue?vue&type=script&lang=js"
import style0 from "./tan_needGz_portrait_botZheCont.vue?vue&type=style&index=0&id=a1fa22e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fa22e8",
  null
  
)

export default component.exports